import { useState } from 'react'
import { H3, Label } from '../Text'
import { toast } from 'react-toastify'
import Circle from '../Animation/Circle'
import { Button } from '../Buttons'
import { Request } from '../../hooks/Request'
import FormDefault from '../Forms/FormDefault'
import TableComplete from '../Tables/TableComplete'
import { requestAuth } from '../services/RequestService'
import { useDialog } from '../../contexts/DialogContext'
import { DialogConfirmation } from '../Modal'

const InputDataPrecintos = ({ field }) => {
	const { openDialog, dialogClose } = useDialog()

	const { data: subData, loading, call } = Request({
		urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
	})

	const { data: documentValues, loading: loadDocument, call: callDocument } = Request({
		urlApi: field.urlApi,
	})

	const { data: procedureData, loading: loadProcedure } = Request({
		urlApi: `/Procedure/${field.id}/dataValues?fieldnames=codigoDeInterno`,
	})

	function handleForm(item) {
		openDialog(
			<>
				{loadDocument && (
					<FormAddDocument
						data={documentValues}
						procedureData={procedureData}
						item={item}
						reload={() => { call(); callDocument(); }}
						field={field}
						onClose={dialogClose}
					/>
				)}
				<br />
			</>,
		)
	}

	function handleFiles(item) {
		openDialog(
			<FormManageFiles
				item={item}
				procedureData={procedureData}
				reload={() => { call(); callDocument(); }}
				field={field}
				onClose={dialogClose}
			/>
		)
	}

	function handleDelete(item) {
		openDialog(
			<DialogConfirmation
				children={<H3>¿Estas seguro que quieres eliminar este precinto y desvincularlo?</H3>}
				onClose={dialogClose}
				method="delete"
				url={`/dataSet/procedure/subData/${item.id}`}
				handleSuccess={async () => {
					if (item.description3) {
						try {
							await requestAuth("put", `/Dropdown/Option/${item.description3}`, {
								name: item.label,
								type: "Simple",
								data: JSON.stringify({ procedureId: "", companyId: "" }),
								DropdownListLabel: "precintos",
								btnSecondary: false
							});
						} catch (e) { }
					}
					call();
					callDocument();
				}}
				texBtn="Eliminar"
			/>,
		)
	}

	return (
		<div>
			<Label htmlFor={field.name} className={`${field.className} my-[0]`}>
				{field.labelCustom ? field.labelCustom : field.label}
			</Label>
			<div className="flex justify-between items-center bg-slate-50 p-2 rounded-t-lg border-b border-gray-200">
				<H3 className="font-medium text-lg text-start m-0">Lista de precintos adjuntos</H3>
				<Button
					type="button"
					className="px-3 py-1 m-0 text-sm"
					onClick={() => handleForm(null)}
				>
					<i className="fas fa-plus mr-1"></i> Adicionar
				</Button>
			</div>

			<br />
			{!loading ? (
				<Circle />
			) : (
				<div className="w-full">
					<TableComplete
						header={[
							{
								name: 'label',
								label: 'Precinto',
							},
							{
								name: 'description',
								label: 'Observación',
							},
							{
								name: 'description4',
								label: 'Fecha',
								type: 'date',
							},
							{
								name: 'description2',
								label: 'Documentos',
								type: 'custom',
								builder: (val) => {
									try {
										const urls = val ? JSON.parse(val) : [];
										return (
											<div className="flex flex-wrap gap-1">
												{urls.map((url, i) => (
													<a key={i} href={url} target="_blank" rel="noreferrer" className="bg-blue-100 text-blue-700 px-2 py-0.5 rounded text-xs">
														Doc {i + 1}
													</a>
												))}
											</div>
										);
									} catch (e) { return "-"; }
								}
							},
							{
								name: 'add',
								type: 'action',
								label: 'Opciones',
								sticky: true,
								actions: [
									{
										label: 'Documentos',
										icon: 'fas fa-file-alt',
										action: handleFiles,
										color: 'text-[#10b981]',
									},
									{
										label: 'Editar',
										icon: 'fas  fa-edit',
										action: handleForm,
										color: 'text-[#1d4ed8]',
									},
									{
										label: 'Eliminar',
										icon: 'fas fa-trash',
										action: handleDelete,
										color: 'text-red-500',
									},
								],
							},
						]}
						data={subData}
					/>
				</div>
			)}
		</div>
	)
}

const FormAddDocument = ({ data, procedureData, item = null, reload, field, onClose }) => {
	const precintosDisponibles = data ? data.filter((opt) => {
		try {
			const parsed = JSON.parse(opt.data);
			if (item && item.description3 === opt.id.toString()) return true;
			return !parsed.procedureId || parsed.procedureId === "";
		} catch (e) {
			return true;
		}
	})
		.sort((a, b) => Number(a.name) - Number(b.name))
		: [];

	async function onSubmit(values) {
		let selectedPrecinto = null;
		let labelToSave = item?.label || "";
		let optionId = item?.description3 || "";

		if (values.precintoId) {
			selectedPrecinto = precintosDisponibles.find(p => p.id.toString() === values.precintoId.toString());
			if (selectedPrecinto) {
				labelToSave = selectedPrecinto.name;
				optionId = selectedPrecinto.id.toString();
			}
		}

		const payload = {
			...item,
			Label: labelToSave,
			Description: values.Description || "",
			Description4: values.Description4 || "",
			Description3: optionId,
		};

		await requestAuth(
			item ? 'put' : 'post',
			item
				? `/dataSet/procedure/subData/${item.id}`
				: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
			payload,
		)
			.then(async (response) => {
				const registeredSubData = response.data;
				if (selectedPrecinto && (!item || item.description3 !== optionId)) {
					const dropdownPayload = {
						name: selectedPrecinto.name,
						type: selectedPrecinto.type || "Simple",
						data: JSON.stringify({
							procedureId: field.id ? field.id.toString() : "",
							companyId: procedureData?.company?.id ? procedureData.company.id.toString() : "",
							razonSocial: procedureData?.company?.razonSocial || "",
							codigoDeInterno: procedureData?.codigoDeInterno || "",
							dataSetId: registeredSubData?.id ? registeredSubData.id.toString() : "",
							date: registeredSubData?.description4 || "",
							urls: registeredSubData?.description2 ? JSON.parse(registeredSubData.description2) : []
						}),
						DropdownListLabel: "precintos",
						btnSecondary: false
					};
					await requestAuth("put", `/Dropdown/Option/${selectedPrecinto.id}`, dropdownPayload);

					if (item && item.description3 && item.description3 !== optionId) {
						try {
							await requestAuth("put", `/Dropdown/Option/${item.description3}`, {
								name: item.label, type: "Simple", data: JSON.stringify({ procedureId: "", companyId: "" })
							});
						} catch (e) { }
					}
				}

				reload()
				onClose()
				toast.success('Registro de precinto exitoso')
			})
			.catch(() => {
				toast.error('Se produjo un error al guardar')
			})
	}

	return (
		<FormDefault
			tittle={item ? "Editar detalle" : "Adicionar precinto"}
			fields={[
				{
					label: 'Precinto',
					name: 'precintoId',
					type: 'select',
					typeInput: 'select',
					options: precintosDisponibles.map((p) => ({
						label: p.name,
						value: p.id.toString(),
					})),
				},
				{
					label: 'Observación',
					name: 'Description',
					typeInput: 'input',
					type: 'text'
				},
				{
					label: 'Fecha',
					name: 'Description4',
					typeInput: 'date',
					type: 'date'
				},
			]}
			initialValues={{
				precintoId: item ? item.description3 : "",
				Description: item ? item.description : '',
				Description4: item ? item.description4 : '',
			}}
			validationSchema={null}
			onSubmit={onSubmit}
			buttonName={item ? "Guardar cambios" : "Adicionar Precinto"}
		/>
	)
}

const FormManageFiles = ({ item, procedureData, reload, field, onClose }) => {
	const currentFiles = item.description2 ? JSON.parse(item.description2) : []
	const [uploading, setUploading] = useState(false);

	async function uploadFiles(e) {
		const files = e.target.files;
		if (!files || files.length === 0) return;

		setUploading(true);
		const uploadPromises = Array.from(files).map(async (file) => {
			let formData = new FormData();
			formData.append("Name", "Documento_Precinto");
			formData.append("File", file);
			formData.append("originalName", file.name);
			formData.append("Status", "verified");
			formData.append("ProcedureId", field.id);

			const res = await requestAuth("post", "/files", formData);
			return res.data.url;
		});

		try {
			const urls = await Promise.all(uploadPromises);
			await updatePrecintoFiles([...currentFiles, ...urls]);
		} catch (error) {
			toast.error("Error al subir uno o más archivos");
			setUploading(false);
		}
	}

	async function updatePrecintoFiles(newList) {
		const payload = {
			...item,
			Description2: JSON.stringify(newList)
		}

		await requestAuth('put', `/dataSet/procedure/subData/${item.id}`, payload)
			.then(async () => {
				if (item.description3) {
					try {
						const dropdownPayload = {
							name: item.label,
							type: "Simple",
							data: JSON.stringify({
								procedureId: field.id ? field.id.toString() : "",
								companyId: procedureData?.company?.id ? procedureData.company.id.toString() : "",
								razonSocial: procedureData?.company?.razonSocial || "",
								codigoDeInterno: procedureData?.codigoDeInterno || "",
								dataSetId: item.id ? item.id.toString() : "",
								date: item.description4 || "",
								urls: newList
							}),
							DropdownListLabel: "precintos",
							btnSecondary: false
						};
						await requestAuth("put", `/Dropdown/Option/${item.description3}`, dropdownPayload);
					} catch (e) { }
				}
				reload()
				onClose()
				toast.success('Documentos adjuntados con éxito')
			})
			.catch(() => {
				toast.error('Error al actualizar documentos')
			})
			.finally(() => setUploading(false));
	}

	return (
		<div className="w-full p-4">
			<H3 className="mb-4">Gestionar Documentos: {item.label}</H3>

			<div className="mb-6">
				<Label className="mb-2 block font-medium">Subir nuevos archivos (puedes seleccionar varios)</Label>
				<input
					type="file"
					multiple
					onChange={uploadFiles}
					disabled={uploading}
					className="block w-full text-sm text-gray-500
						file:mr-4 file:py-2 file:px-4
						file:rounded-full file:border-0
						file:text-sm file:font-semibold
						file:bg-blue-50 file:text-blue-700
						hover:file:bg-blue-100 cursor-pointer"
				/>
				{uploading && <Circle className="mt-2" />}
			</div>

			<div className="max-h-80 overflow-y-auto border rounded-md p-2 bg-gray-50">
				<Label className="mb-2 block font-bold border-b pb-1">Archivos Adjuntos</Label>
				{currentFiles.length > 0 ? (
					<div className="grid grid-cols-1 gap-2">
						{currentFiles.map((url, idx) => (
							<div key={idx} className="flex justify-between items-center bg-white p-2 rounded shadow-sm border border-gray-200">
								<span className="truncate text-xs font-mono max-w-[70%] text-gray-600">{url.split('/').pop()}</span>
								<a href={url} target="_blank" rel="noreferrer" className="text-blue-600 hover:text-blue-800 text-sm font-medium">
									<i className="fas fa-external-link-alt mr-1"></i>Ver
								</a>
							</div>
						))}
					</div>
				) : (
					<p className="text-gray-400 italic text-center py-4">No hay documentos registrados</p>
				)}
			</div>

			<div className="mt-6 flex justify-end">
				<Button onClick={onClose} className="bg-gray-500">Cerrar</Button>
			</div>
		</div>
	)
}

export default InputDataPrecintos
